import { Api } from '@axiom/ui';
import type {
  Account,
  AccountNewEngagementAssignment,
} from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

export type ReadAccountsPayload = {
  data: Account[];
  meta: { currentPage: number; pageCount: number; resultCount: number };
};

class AccountApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
    });
  }

  readAccounts(filterMeta?: { search?: string; page?: number }) {
    return super.read<ReadAccountsPayload>({
      endpoint: `/accounts`,
      method: 'GET',
      query: filterMeta,
    });
  }

  readAccountNewEngagementAssignment(
    accountId: Account['id'],
    query?: { contactId?: Account['contacts'][number]['id'] }
  ) {
    return super.read<{ data: AccountNewEngagementAssignment }>({
      endpoint: `/accounts/${accountId}/newEngagementAssignment`,
      method: 'GET',
      query,
    });
  }

  async patchAccount(accountId: Account['id'], body: Account) {
    return super.write<{ data: Account }>({
      endpoint: `/accounts/${accountId}`,
      body,
      method: 'PATCH',
    });
  }

  async refreshAccount(accountId: Account['id']) {
    return super.invalidate(`/accounts/${accountId}`);
  }

  refreshAccountNewEngagementsAssignment(
    accountId: Account['id'],
    query?: { contactId?: Account['contacts'][number]['id'] }
  ) {
    // invalidate doesn't work in this use case because we always need to call this
    // endpoint. Invalidate can only call something that has been called before
    super.clear(`/accounts/${accountId}/newEngagementAssignment`);
    return this.readAccountNewEngagementAssignment(accountId, query);
  }
}

export const AccountApi = new AccountApiClass();
